import EventSource from "eventsource";
const ERROR_MESSAGE = "[ERROR] 429_TOO_MANY_REQUESTS";
const DONE_MESSAGE = "[DONE]";
export default class Stream {
  constructor(apiEndpoint) {
    this.apiUrl = `${process.env.VUE_APP_AI_URL}${apiEndpoint}?stream=1`;
    this.instance = undefined;
    this.message = "";
  }

  connect() {
    this.instance = new EventSource(this.apiUrl, {
      headers: { Authorization: process.env.VUE_APP_AI_AUTH_TOKEN }
    });
  }

  onError(errorHandler) {
    this.instance.onerror = errorHandler;
  }

  onMessage(callback) {
    return new Promise((resolve, reject) => {
      this.instance.onmessage = event => {
        this.verifyOrigin(event.origin);
        if (event.data.trim() === DONE_MESSAGE) {
          resolve("Success");
          this.close();
          return;
        }

        if (event.data.trim() === ERROR_MESSAGE) {
          reject("Error");
          this.close();

          return;
        }
        this.message += event.data;
        callback(this.message);
      };
    });
  }

  close() {
    this.instance.close();
  }

  verifyOrigin(origin) {
    const apiUrl = new URL(process.env.VUE_APP_AI_URL);

    if (apiUrl.origin !== origin) {
      this.close();
      return;
    }
  }
}
